import { Download } from "lucide-react";
import { useState } from "react";
import { generateCapabilityBrief } from "@/lib/capabilityBrief";

export default function CapabilityBriefDownload() {
  const [error, setError] = useState("");

  const handleDownload = () => {
    setError("");
    try {
      generateCapabilityBrief();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "The capability brief could not be generated.");
    }
  };

  return (
    <div className="brief-download-wrap">
      <button type="button" className="button button-navy brief-download" onClick={handleDownload} data-testid="capability-sheet-download"><Download size={16} /> Download capability brief</button>
      {error && <span className="brief-download-error" role="alert" data-testid="capability-sheet-error">{error}</span>}
    </div>
  );
}
